import React, { useEffect } from 'react';
import postscribe from 'postscribe'
import { ModalController } from '../../Managers/exports';
import "./b.css"

export const BlackBod = () => {

    useEffect(() => {
        postscribe('#bbox-root', '<script type="text/javascript">\
        window.bboxInit = function () {\
        bbox.showForm("c1a8364a-6414-4584-beac-cc7a77184db0");\
        };\
        (function () {\
        var e = document.createElement("script"); e.async = true;\
        e.src = "https://bbox.blackbaudhosting.com/webforms/bbox-min.js";\
        document.getElementsByTagName("head")[0].appendChild(e);\
        } ());\
        </script>')
    },[])

    return(
    <div style={{  overflowY: "scroll", paddingBottom: 100}}>
        <div className="black-close" onClick={ModalController.close}>
            &times;
        </div>
        <div id="bbox-root" style={{
            overflowY: "scroll"
        }}>

        </div>

        <div className="form-footer-container">
            <div className="form-footer">
                <button id="close" onClick={ModalController.close} className="modal-btn form-footer-close-button">Close</button>
            </div>
        </div>
    </div>)



}